import actionTypes from './ActionTypes';
import request from '../../utils/request';
import apiSettings from '../../config/api';

const getUserOrders = () => {
  return dispatch => {
    const url = apiSettings.endpoints.genUserGetMyOrdersUrl();
    request
      .post(url, {}, dispatch, actionTypes.GET_USER_ORDERS)
      .then((res) => {
        dispatch({type: actionTypes.GET_USER_ORDERS.fulfilled, data: res.data});
      })
  }
};

const getUserOrder = (data) => {
  return dispatch => {
    const url = apiSettings.endpoints.genUserGetOneOrder();
    request
      .post(url, data, dispatch, actionTypes.GET_USER_ORDER)
      .then((res) => {
        dispatch({type: actionTypes.GET_USER_ORDER.fulfilled, data: res.data.order || null});
      })
  }
};

export {getUserOrders, getUserOrder}


// WEBPACK FOOTER //
// ./src/app/containers/UserOrders/Actions.js